module.exports = __webpack_public_path__ + "static/media/pelikanSecurityLogo.d745a211.png";